<template>
  <div class="period-container">
    <el-form-item>
      <el-radio-group v-model="periodValue">
        <el-radio-button label="day">日</el-radio-button>
        <el-radio-button label="week">周</el-radio-button>
        <el-radio-button label="month">月</el-radio-button>
        <el-radio-button label="year">年</el-radio-button>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="年份" v-if="periodValue === 'year'">
      <el-date-picker
        v-model="year"
        type="year"
        value-format="yyyy"
        :editable="false"
        :picker-options="yearPickerOptions"
        @change="handleYearChange"
        :clearable="false"
      />
    </el-form-item>

    <el-form-item :key="periodValue" label="日期范围" v-else>
      <el-date-picker
        :clearable="false"
        v-model="dateRange"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        :picker-options="dateRangePickerOptions"
        :editable="false"
        @focus="handleDatePickerFocus"
      >
      </el-date-picker>
    </el-form-item>
  </div>
</template>

<script>
import { Vue, Component, Mixins, PropSync, Watch } from 'vue-property-decorator';
import moment from 'moment';

// 最大的日期范围
const PERIOD_MAP = {
  day: 5,
  week: 28,
  month: 90,
  year: 365
}

// 默认的日期范围
const PERIOD_DEFAULT_MAP = {
  day: 5,
  week: 14,
  month: 30,
  year: 365
}

@Component
export default class Period extends Mixins(Vue) {
  @PropSync('period', { type: String }) periodValue; // 'day' | 'week' | 'month' | 'year'
  @PropSync('created_gteq_date', { type: String }) createdGteqDateValue; // '2025-01-01'
  @PropSync('created_lteq_date', { type: String }) createdLteqDateValue; // '2025-01-05'

  dateRangePickerOptions = {};
  yearPickerOptions = {
    disabledDate: (date) => {
      return date.valueOf() > Date.now();
    }
  };
  pickDateRange = [];
  year = null;

  created() {
    this.dateRangePickerOptions = {
      onPick: ({ maxDate, minDate }) => {
        this.pickDateRange = [minDate, maxDate].filter(Boolean);
      },

      disabledDate: (date) => {
        // 禁用未来日期
        if (date.valueOf() > Date.now()) {
          return true;
        }

        if (this.pickDateRange.length === 1) {
          const targetDate = moment(date);
          const maxDate = moment(this.pickDateRange[0]).add(PERIOD_MAP[this.periodValue] - 1, 'days');
          const minDate = moment(this.pickDateRange[0]).subtract(PERIOD_MAP[this.periodValue] - 1, 'days');

          return targetDate.isAfter(maxDate) || targetDate.isBefore(minDate);
        }

        return false;
      }
    }

    this.dateRange = this.getDateRangeByPeriod(this.periodValue);
  }

  get dateRange() {
    return [this.createdGteqDateValue, this.createdLteqDateValue].filter(Boolean);
  }

  set dateRange(value) {
    this.createdGteqDateValue = value[0];
    this.createdLteqDateValue = value[1];
  }


  handleDatePickerFocus() {
    this.pickDateRange = [];
  }

  getDateRangeByPeriod(period) {
    if (period === 'year') {
      const date = moment(`${this.year}-01-01`);
      return [date.startOf('year').format('YYYY-MM-DD'), date.endOf('year').format('YYYY-MM-DD')];
    }

    return [
      moment().subtract(PERIOD_DEFAULT_MAP[period] - 1, 'days').format('YYYY-MM-DD'),
      moment().format('YYYY-MM-DD')
    ];
  }

  handleYearChange(year) {
    const date = moment(`${year}-01-01`);
    this.dateRange = [date.startOf('year').format('YYYY-MM-DD'), date.endOf('year').format('YYYY-MM-DD')];
  }

  @Watch('periodValue')
  handlePeriodChange(period) {
    if (period === 'year') {
      this.year = moment().year().toString();
    }

    this.pickDateRange = [];
    this.dateRange = this.getDateRangeByPeriod(period);
  }
}
</script>

<style lang="scss" scoped>
.period-container {
  display: inline-flex;
  vertical-align: middle;
}
</style>
